import * as React from 'react';
import {useState} from 'react';
import Navigation from '../../../../components/Navigation';
import Attribute from './Attribute';

const ATTRIBUTES = [
  {
    id: 'materialFormats',
    menuTitle: 'Material Formats',
  },
  {
    id: 'materialColours',
    menuTitle: 'Material Colours',
  },
];

const Attributes = () => {
  const [selected, setSelected] = useState('materialFormats')

  return selected ? (
    <Navigation
      items={ATTRIBUTES}
      current={selected}
      onSelect={({id}) => setSelected(id)}
    >
      {selected === 'materialFormats' ? (
        <Attribute
          singularName="Format"
          pluralName="Formats"
          serviceName="materialFormat"
        />
      ) : (
        <Attribute
          singularName="Colour"
          pluralName="Colours"
          serviceName="materialColour"
        />
      )}
    </Navigation>
  ) : null;
};

export default Attributes;
